/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmContractStatusInfo = {
    CTRTADDR: string;
    STS: EvmContractStatusInfo.STS;
};

export namespace EvmContractStatusInfo {

    export enum STS {
        ALREADY_VERIFIED = 'ALREADY_VERIFIED',
        UNVERIFIED = 'UNVERIFIED',
        NOT_CA = 'NOT_CA',
    }


}

